import { render, staticRenderFns } from "./CreateTradeContractForm.vue?vue&type=template&id=40e3cf10&scoped=true&"
import script from "./CreateTradeContractForm.vue?vue&type=script&lang=js&"
export * from "./CreateTradeContractForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e3cf10",
  null
  
)

export default component.exports